import { render } from "./Style.vue?vue&type=template&id=477bfd96&scoped=true"
import script from "./Style.vue?vue&type=script&lang=js"
export * from "./Style.vue?vue&type=script&lang=js"

import "./Style.vue?vue&type=style&index=0&id=477bfd96&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477bfd96"]])

export default __exports__